import { FlowMode, HelperFlowService } from '../services/helper-flow.service';
import { TareaFinalizacion } from '../models/tarea.model';
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy,
  EventEmitter,
  Output,
  ComponentFactoryResolver,
  OnDestroy,
} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  Const,
  Context,
  Tarea,
  TaskEvent,
  ConfigFinishDefault,
  NameTaskType,
  UsuarioActual,
  TareaRol,
  Static,
  ContextAutoSave
} from '@app/shared';
import { TaskPreviewService } from './shared/task-preview.service';
import { CssStatus } from '../services/util';
import { DragulaService } from 'ng2-dragula';
import { findKey, find, filter } from 'lodash';
import { AuthenticationService } from '@app/core';
import { NotifierService } from '../services/notifier.service';

import { Subject } from 'rxjs';
import { environment } from '@env/environment';
import { SessionStorageManagement } from '../Library/session-storage-management';

// Lista de estados para la tarea
const cssStatus = Const.CSS_STATUS;
const status = {
  finalizado: cssStatus.finished,
  pendiente: cssStatus.pending,
  inactivo: cssStatus.inactive,
  secundaria_progreso: cssStatus.secondaryProgress
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'iw-task-preview',
  templateUrl: './task-preview.component.html',
  styleUrls: ['./task-preview.component.scss'],
  providers: [TaskPreviewService, HelperFlowService, SessionStorageManagement]
})
export class TaskPreviewComponent implements OnInit, OnDestroy {
  // Contiene el tipo de proceso que se esta renderizando
  @Input() typeProcess = 'process';
  // Contiene informacion que se desee compartir en caso de dar click a la tarea
  @Input() sharedData: any;
  // Define el formato en el que el usuario desea ver la informacion de las tareas
  @Input()
  set isDesignTask(value: string) {
    this.defineDesignTask(value);
  }
  // Id del tramite actual
  @Input() idTramite: number;
  // Determina si esta tarea pertenece a un trámite por default o una instancia
  @Input() belongsToInstance = true;
  // Determina si la tarea es de un flujo para asociacion externa a una tarea
  @Input() externalAssociation = false;
  // Contiene el encabezado del flujo
  @Input() headerFlow: TemplateRef<any>;
  // define cuando es una tarea de utilitarios
  @Input() utilitariosTask = false;
  // Tarea actual
  @Input()
  set task(v: Tarea) {
    // Validar si el estado coincide con una key de "states"
    if (v && v.tarea_estado && status.hasOwnProperty(v.tarea_estado.nombre)) {
      this._status = status[v.tarea_estado.nombre];
    } else {
      this._status = status.pendiente;
    }
    this._task = v;
  }
  get task() {
    return this._task;
  }
  // Estado de la tarea
  get status() {
    return this._status;
  }
  // Determina si se activa el evento de eliminar en la tarea
  @Input() activateDeleteAction = false;
  // Referencia del modal que contiene el formulario
  modalRef: BsModalRef;
  // Contiene el usuario en sesion
  user: UsuarioActual;
  // Determina si se esta realizando alguna petición al backend
  @Input() isLoading = false;
  // Determina el comportamiento de la actividad con respecto al flujo
  @Input() flowMode: FlowMode = 'normal';
  // Determina la instancia de donde se esta ejecutando el flujo
  @Input() typeProcessInstance: string;
  // Constante nombre de las tareas asignacion
  textAsignacion = Const.TYPES_TASK.assignment;
  // Constante nombre de las tareas microproceso
  textMicroprocess = Const.TYPES_TASK.microProcess;
  // Define el responsable de la tarea
  responsable: 'asignado' | 'sin_asignar' | 'no_asignado' = 'sin_asignar';
  // Define si el funcionario tiene permiso para gestinar usuarios
  manageUser = false; 
  // Define cuando se colapsa la informacion de grupos y responsables de la tarea
  isCollapsed = {
    infoBasic: true,
    InfoResponsible: true,
  };
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    update: false,
    delete: false,
    modify: false
  };
  // Contexto base de los formularios
  contextForm: Partial<Context> = {};
  // Acumula las tareas a ejecutar auto guardado
  contextAutoSave: ContextAutoSave[] = [];
  // Referencia al template para formularios dentro de la modal
  @ViewChild('modalForm') private modalFormTpl: TemplateRef<any>;
  // Referencia a la modal de reasignación
  @ViewChild('modalReassign') private modalReassign: TemplateRef<any>;
  // Referencia a la modal del historial
  @ViewChild('modalHistory') private modalHistory: TemplateRef<any>;
  // Referencia a la modal del historial de usuarios
  @ViewChild('modalHistoryUser') private modalHistoryUser: TemplateRef<any>;
  // Referencia a la modal de gestion de responsables
  @ViewChild('modalManageUsers') private modalManageUsers: TemplateRef<any>;
  // Referencia al template para formularios fuera de la modal
  @ViewChild('outModal') private outModalTpl: TemplateRef<any>;
  private _status: CssStatus;
  private _task: Tarea;
  _changeTaskTitle: boolean = false;
  // Controla si se muestra las tareas asociadas
  private destroy: Subject<void> = new Subject<void>();
  // Evento de la acción eliminar
  @Output() actionDelete = new EventEmitter<boolean>();
  // Evento de la acción click
  @Output() click = new EventEmitter<boolean>();
  // Evento de reasignación completado
  @Output() validReassign = new EventEmitter<boolean>();

  constructor(
    private ts: TaskPreviewService,
    private ns: NotifierService,
    public bms: BsModalService,
    private ds: DragulaService,
    private as: AuthenticationService,
    private cfr: ComponentFactoryResolver,
    private hfs: HelperFlowService,
    private sst: SessionStorageManagement,
  ) { }

  ngOnInit() {
    if (this.typeProcessInstance) {
      this.contextForm.typeProcess = this.typeProcessInstance;
    } else {
      this.contextForm.typeProcess = this.typeProcess;
    }
    this.contextForm.headerFlow = this.headerFlow;
    if (!this.belongsToInstance) {
      this.activateAction.update = this.as.confirmPermission(
        Const.types_permissions.administrationProcess,
        Const.types_action_permissions.update,
      );
      this.activateAction.delete = this.as.confirmPermission(
        Const.types_permissions.administrationProcess,
        Const.types_action_permissions.delete,
      );
      this.isCollapsed.infoBasic = false;
    }
    //Determina si un usuario puede modificar una tarea
    this.activateAction.modify = this.as.confirmPermission(
      Const.types_permissions.instanceProcess,
      Const.types_action_permissions.modifyTask,
    );
    // Obtener usuario autenticado
    this.user = this.as.getCredentials();
    if (this.task && this.task.responsables && this.task.responsables.length) {
      if (this.user) {
        const assigned = find(this.task.responsables, {id: this.user.user_id});
        if (assigned) {
          this.responsable = 'asignado';
        } else {
          this.responsable = 'no_asignado';
        }
      } else {
        this.responsable = 'no_asignado';
      }
    }
    if(environment.changeTaskAssignationName && this.task.tarea_tipo.nombre == this.textAsignacion){
      this._changeTaskTitle = true;
    }
    //Determina si el usuario tiene permisos para gestionar usuarios
    let validGeneralPermission = this.as.confirmPermission(
      Const.types_permissions.instanceProcess,
      Const.types_action_permissions.manageUsersTask,
    );
    let validResposiblePermission = this.as.confirmPermission(
      Const.types_permissions.instanceProcess,
      Const.types_action_permissions.manageUsersTaskValidResponsible,
    );
    if(validGeneralPermission == true){
      this.manageUser = true;
    }else if(validResposiblePermission == true && this.responsable === 'asignado'){
      this.manageUser = true;
    }else{
      this.manageUser = false;
    }
    let validSession = this.sst.validSessionStorage();
    if(validSession){
      this.sst.deleteMasterTaskPersistentData(this._task.id);
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
    let validSession = this.sst.validSessionStorage();
    if(validSession){
      this.sst.deleteMasterTaskPersistentData(this._task.id);
    }
  }

  /**
   * Abre una modal y actualiza una referencia global con acceso a la misma.
   *
   * @param {TemplateRef<any>} template
   * @param nameRef
   * @param klass
   * @memberof ActivityComponent
   */
  openModal(template: TemplateRef<any>, nameRef: string, klass: string = '') {
    this[nameRef] = this.bms.show(template, { class: klass });
  }

  /**
   * Compara un string con el tipo actual de la tarea.
   *
   * @param {NameTaskType} type
   * @returns
   * @memberof TaskComponent
   */
  myTypeIs(type: NameTaskType) {
    if(this.task.tarea_tipo){
    const currentType = findKey(
      Const.TYPES_TASK, (t) => t === this.task.tarea_tipo.nombre
    );
    return type === currentType;
  } else {
    return false;
  }
  }

  /**
   * Atiende al evento click de la tarea.
   *
   * @memberof TaskComponent
   */
  clicked() {
    // Lista de modos en los que nos e permite el click
    const blockModesForRun = ['completion', 'association', 'reports'];
    if (this.belongsToInstance) {
      if (!blockModesForRun.includes(this.flowMode)) {
        this.runTask();
      }
    } else {
      if (this.flowMode !== 'reports' && this.flowMode !== 'etapas') {
        if (this.externalAssociation) {
          if (this.task.tarea_tipo.nombre !== Const.TYPES_TASK.microProcess) {
            this.editTask();
          } else {
            this.notifyTask('runMicroProcess');
          }
        } else {
          this.editTask();
        }
      } else {
        this.selectedTask();
      }
    }
  }


  /**
   * Realiza la notificación “openInternalTaskInformation” para abrir el modal informacion interna de la tarea
   *
   * @memberof TaskComponent
   */
  utilitariosTaskNotifier(type:any) {
    if(type == "informacion"){
      this.notifyTask('openInternalTaskInformation');
    }
    else if(type == "asignacion"){
      this.notifyTask('openTaskAssignation');
    }
  }

  /**
   * Gestina las diferentes notificaciones del componente
   *
   * @private
   * @param {string} action
   * @param {{}} [data=null]
   * @param {boolean} [notData=false]
   * @memberof TaskComponent
   */
  private notifyTask(action: string, data: {} = null, notData: boolean = false, modify: boolean = false) {
    if (!notData && !data) {
      data = {
        task: this.task
      };
      if (this.sharedData) {
        data['sharedData'] = this.sharedData;
      }
    }
    this.ns.set({
      source: 'task-preview',
      eventTriggered: 'click',
      action: action,
      instance: this.typeProcessInstance ? this.typeProcessInstance : this.typeProcess,
      data: data, 
      modify: false
    });
      this.task['modificar'] = false;
  }

  /**
   * Cierra el formulario de la tarea activa.
   *
   * @memberof TaskComponent
   */
  closeForm() {
    const renderIn = this.task.meta.formType.config.renderIn;
    switch (renderIn) {
      case 'modal':
        this.modalRef.hide();
        break;
      case 'view':
        // Notificar evento click con una acción
        this.notifyTask('closeTaskForm', null, true);
        break;
    }
  }

  /**
   * Determina el comportamiento de un evento solicitado por el formulario.
   * Los eventos posibles son los definidos en la interface 'TaskEvent'.
   *
   * @param {TaskEvent} e
   * @memberof TaskComponent
   */
  manageEvent(e: TaskEvent) {
    let skipFinish = false;
    if (e.hasOwnProperty('params')) {
      skipFinish = e.params.hasOwnProperty('skip') ? e.params.skip : false;
    }
    switch (e.type) {
      // case 'finish':
      //   this.finish(e.data, skipFinish);
      //   break;
      case 'closeForm':
        this.closeForm();
        break;
      // case 'updateTask':
      //   this.notifyTask('updateTask', e.data);
      //   break;
      case 'refreshFlow':
        this.notifyTask('refreshFlow');
        break;
      // case 'startSecondary':
      //   this.closeForm();
      //   this.notifyTask('startSecondary', e.data);
      //   break;
    }
  }

  /**
   * Finalizar la tarea según su tipo.
   *
   * @param {*} data
   * @param skip
   * @memberof TaskComponent
   */
  async finish(data: any, skip: boolean = false) {
    if (data && data['tramite_asociacion']) {
      this.notifyTask('isLoadingAssociationTramite');
      await this.ts.associationProcess(data['tramite_asociacion'], this.idTramite,data['document_asociacion']).catch(
        _err => {
          this.notifyTask('isLoadingAssociationTramite');
        }
      );
      this.notifyTask('isLoadingAssociationTramite');
    }
    // Inicio finalizacion tarea
    this.notifyTask('isLoadingFinishTask');
    let isFinished: boolean;
    let autoSaved = false;
    switch (this.task.tarea_tipo.nombre) {
      // Ninguna, condición y forma especifica
      case Const.TYPES_TASK.none:
      case Const.TYPES_TASK.condition:
      case Const.TYPES_TASK.form:
        if (data['id_opciones'] && data['id_opciones'].length) {
          let f = true;
          isFinished = true;
          await this.asyncForEach(data['id_opciones'], async (el: number) => {
            const d: ConfigFinishDefault = {
              tarea: data['tarea'],
              id_opcion: el
            };
            f = await this.ts.finishDefault(d);
            if (!f) {
              isFinished = false;
            }
          });
        } else {
          isFinished = await this.ts.finishDefault(data as ConfigFinishDefault);
        }
        break;
    }
    if (isFinished) {
      let automaticEndings: TareaFinalizacion[];
      if (data['id_opciones'] && data['id_opciones'].length) {
        automaticEndings = filter(
          this.task.tarea_finalizacion,
          f => data['id_opciones'].indexOf(f.opcion) && f.parametros['auto_guardado'] && f.tarea_destino
        );
      } else if (data['id_opcion']) {
        automaticEndings = filter(
          this.task.tarea_finalizacion,
          f => f.parametros['auto_guardado'] && f.tarea_destino && f.opcion === data['id_opcion']
        );
      } else {
        automaticEndings = filter(
          this.task.tarea_finalizacion, f => f.parametros['auto_guardado'] && f.tarea_destino
        );
      }
      // Fin de la finalizacion de la tarea
      this.notifyTask('closeLoadingFinishTask');
      // Acumular las tareas con auto guardado para enviarlas a ejecutar
      if (automaticEndings.length) {
        autoSaved = true;
        this.notifyTask('alertLoadDynamic', 'Ejecutando auto guardado de tareas');
        await Static.asyncForEach(automaticEndings, async endings => {
          if (endings.tarea_destino) {
            const task = await this.ts.getInstanceTask(endings.tarea_destino);
            // Obtener el formulario para renderizar la tarea
            let formType = null;
            const name = task.tarea_tipo.nombre === Const.TYPES_TASK.form ?
                    task ?
                      task.tarea_forma ?
                        task.tarea_forma.length ?
                          task.tarea_forma[0].nombre
                        : undefined
                      : undefined
                    : undefined
                   : undefined;
            if (task.tarea_tipo.nombre !== Const.TYPES_TASK.microProcess) {
              const forma: Array<any> = new Array(task.tarea_forma);
              if (forma[0].length > 0) {
                formType = this.hfs.getFormType(task.tarea_tipo.nombre, name, task.tarea_forma[0].forma_especifica);
              } else {
                formType = this.hfs.getFormType(task.tarea_tipo.nombre, name, true);
              }
            }
            task.meta = {
              idActivity: task['tarea_actividad']['id'] ? task['tarea_actividad']['id'] : null,
              formType: formType
            };
            this.contextAutoSave.push({
              idTaskOrigin: endings.tarea_inicio,
              task: task,
              typeProcess: this.typeProcess,
              messageLoad: endings.parametros['auto_guardado']
            });
          }
        });
        if (this.contextAutoSave.length) {
          // Ejecutar auto guardado
          this.notifyTask('autoSave', this.contextAutoSave);
        } else {
          this.notifyTask('finishTask');
        }
      }
    }
    // Refrescar flujo.
    // Se usa skip = true, si se quiere saltar al evento 'finishTask' del flujo.
    // Cuando es una asignación se usa skip = true.
    if ((isFinished || skip) && !autoSaved) {
      this.notifyTask('finishTask');
    }
  }

  /**
   * Notifica al flujo el evento de eliminar la tarea.
   *
   * @memberof TaskComponent
   */
  removeTask() {
    if (!this.activateDeleteAction) {
      this.notifyTask('removeTask');
    } else {
      this.actionDelete.emit(true);
    }
  }

  /**
   * Concatena todos los grupos validando si se desean los de responsables o asignaciones
   *
   * @param {Array<TareaRol>} [groups=[]]
   * @param {boolean} [isResponsible=true]
   * @returns {string}
   * @memberof TaskComponent
   */
  concatTextGroupResponsible(groups: Array<TareaRol> = [], isResponsible: boolean = true): string {
    let textConcat = '';
    let firstGroupResponsible = true;
    groups.forEach(group => {
      if (isResponsible) {
        if (group.responsable) {
          if (!firstGroupResponsible) {
            textConcat += ', ';
          } else {
            firstGroupResponsible = false;
          }
          textConcat += group.nombre;
        }
      } else {
        if (group.asignacion) {
          if (!firstGroupResponsible) {
            textConcat += ', ';
          } else {
            firstGroupResponsible = false;
          }
          textConcat += group.nombre;
        }
      }
    });
    return textConcat;
  }

  /**
   * Ejecuta la tarea, esto solo aplica cuando esta pertenece a una instancia.
   * Notifica cual fué la tarea a la que se le dio click y/o abre la modal.
   *
   * @private
   * @memberof TaskComponent
   */
  private async runTask() {
    this.notifyTask('alertLoadDynamic','Cargando información de tarea...');
    const taskData = await this.ts.getInstancePrincipalTask(this.task.id);
    const typesTask = Const.TYPES_TASK;
    if (taskData){
      this.task.documentos = taskData.documentos;
      this.task.documentos_modificacion = taskData.documentos_modificacion;
      this.task.tarea_asociacion = taskData.tarea_asociacion;
      this.task.tarea_condicion = taskData.tarea_condicion;
      this.task.tarea_finalizacion = taskData.tarea_finalizacion;
      this.task.rechazo = taskData.rechazo;
      const data: any = {
        task: this.task
      };
      let action;
  
      // Cuando la tarea es un microproceso
      if (this.task.tarea_tipo.nombre === typesTask.microProcess) {
        action = 'runMicroProcess';
      } else if (this.task.tarea_tipo.nombre === typesTask.secondary) {
        action = 'runSecondary';
      } else {
        // Renderizar el formulario.
        // Nota: en el momento el formulario se puede renderizar en
        // una modal o en la vista principal del flujo.
        const formType = this.task.meta.formType;
        switch (formType.config.renderIn) {
          case 'modal':
            action = 'openFormModal';
            this.openModal(this.modalFormTpl, 'modalRef');
            break;
          case 'view':
            action = 'openFormOutModal';
            data.template = this.outModalTpl;
            break;
        }
      }
      this.notifyTask('alertLoadDynamic');
      // Notificar evento click con una acción
      this.notifyTask(action, data);
    }
    
  }

  /**
   * Muestra la información de la tarea para ser posteriormente editada,
   * esto solo funciona si la tarea pertenece a un trámite por default.
   *
   * @private
   * @memberof TaskComponent
   */
  private editTask() {
    this.notifyTask('editTask');
  }

  /**
   * Genera una notificacion con la tarea seleccionada
   * donde la notificacion cambia dependiendo de si es o no un microproceso
   * esto solo funciona para los flujos de modo: 'reports'
   *
   * @private
   * @memberof TaskComponent
   */
  private selectedTask() {
    if (this.task.tarea_tipo.nombre !== Const.TYPES_TASK.microProcess) {
      this.notifyTask('selectTask');
    } else {
      this.notifyTask('runMicroProcess');
    }
  }

  /**
   * Ejecuta un for de forma sincronica
   *
   * @private
   * @param {Array<any>} array
   * @param {*} callback
   * @memberof TaskComponent
   */
  private async asyncForEach(array: Array<any>, callback: any) {
    for (let index = 0; index < array.length; index++) {
      await callback(array[index], index, array);
      continue;
    }
  }

  /**
   * Controla los tipos de diseños seleccionado por el usuario
   *
   * @memberof TaskComponent
   */
  private defineDesignTask(design: string) {
    switch (design) {
      case 'minimum':
        this.isCollapsed.infoBasic = true;
        this.isCollapsed.InfoResponsible = true;
        break;
      case 'maximum':
        this.isCollapsed.infoBasic = false;
        this.isCollapsed.InfoResponsible = false;
        break;
      default:
        this.isCollapsed.infoBasic = false;
        this.isCollapsed.InfoResponsible = true;
        break;
    }
  }

  /**
   *Abre la modal de reasignación
   *
   * @memberof TaskComponent
   */
  openReassignModal(){
    this.openModal(this.modalReassign, 'modalRef', 'modal-lg-personalized');
  }

  /**
   *Abre la modal del historial
   *
   * @memberof TaskComponent
   */
  openHistory(){
    this.openModal(this.modalHistory, 'modalRef', 'modal-lg-personalized');
  }

  /**
   *Abre la modal del historial de responsables
   *
   * @memberof TaskComponent
   */
   openHistoryUser(){
    this.openModal(this.modalHistoryUser, 'modalRef', 'modal-lg-personalized');
  }

  /**
   *Abre la modal de gestion de usuarios
   *
   * @memberof TaskComponent
   */
   openManageUserModal(){
    this.openModal(this.modalManageUsers, 'modalRef', 'modal-lg-personalized');
  }

  /**
   *Refresca el flujo al finalizar reasignación
   *
   * @memberof TaskComponent
   */
  refreshFlow(data: boolean){
    if(data){
      this.modalRef.hide();
      this.validReassign.emit(true);
    }
  }

  /**
   *Cierra la modal de reasignación
   *
   * @memberof TaskComponent
   */
  closeModalReassign(){
    this.modalRef.hide();
  }

  /**
   *Cierra la modal
   *
   * @memberof TaskComponent
   */
   closeModal(){
    this.modalRef.hide();
  }

  /**
   *Evento cuando se le da click al ícono Lápiz (modificar radicación si aplica)
   *
   * @memberof TaskComponent
   */
  async modify(){
    const taskData = await this.ts.getInstancePrincipalTask(this.task.id);
    const typesTask = Const.TYPES_TASK;
    if (taskData){
      this.task.documentos = taskData.documentos;
      this.task.documentos_modificacion = taskData.documentos_modificacion;
      this.task.tarea_asociacion = taskData.tarea_asociacion;
      this.task.tarea_condicion = taskData.tarea_condicion;
      this.task.tarea_finalizacion = taskData.tarea_finalizacion;
      this.task.rechazo = taskData.rechazo;
      const data: any = {
        task: this.task
      };
      let action;

      // Cuando la tarea es un microproceso
      if (this.task.tarea_tipo.nombre === typesTask.microProcess) {
        action = 'runMicroProcess';
      } else if (this.task.tarea_tipo.nombre === typesTask.secondary) {
        action = 'runSecondary';
      } else {
        // Renderizar el formulario.
        // Nota: en el momento el formulario se puede renderizar en
        // una modal o en la vista principal del flujo.
        const formType = this.task.meta.formType;
        switch (formType.config.renderIn) {
          case 'modal':
            action = 'openFormModal';
            this.openModal(this.modalFormTpl, 'modalRef');
            break;
          case 'view':
            action = 'openFormOutModal';
            data.template = this.outModalTpl;
            break;
        }
      }
      // Notificar evento click con una acción
      this.notifyTask(action, data, false, false);
    }
  }
} // End class



// WEBPACK FOOTER //
// ./src/app/shared/task-preview/task-preview.component.ts